let media = [
    {
        path: '/media/video',
        name: 'list',
        component: () => import('@/views/media/video/list.vue'),
        meta: {keepAlive: true, parentPath: 'media'},
    },
    {
        path: '/media/video/edit',
        name: 'edit',
        component: () => import('@/views/media/video/edit.vue'),
        meta: {keepAlive: true, parentPath: 'media'},
    },
    {
        path: '/media/classify',
        name: 'classify',
        component: () => import('@/views/media/classify.vue'),
        meta: {keepAlive: true, parentPath: 'media'},
    },
    {
        path: '/media/subject',
        name: 'subject',
        component: () => import('@/views/media/subject.vue'),
        meta: {keepAlive: true, parentPath: 'media'},
    }

    
    
]
export default media


// WEBPACK FOOTER //
// ./src/router/media.js